var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimsMagicMoment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.732V2.95703",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8987 16.9993H2.81874C2.81874 16.9993 1.76069 16.9813 1.30326 16.5413C1.13393 16.3771 1 15.9844 1 15.7715",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3011 1H2.36967C1.61628 1 1 1.59687 1 2.32588V2.672C1 3.40104 1.61631 3.99787 2.36967 3.99787H13.8987V6.74345",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6572 1C12.6572 1 11.2909 2.59269 13.2982 3.99791",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 11.9385C17.0001 13.9012 15.3999 15.4922 13.4258 15.4922C11.4518 15.4922 9.85156 13.9012 9.85156 11.9385C9.85156 9.97583 11.4518 8.38477 13.4258 8.38477C15.3999 8.38477 17.0001 9.97583 17.0001 11.9385Z",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2963 11.7153L13.1317 12.6325L14.6605 11.0898",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsMagicMoment);
export default __webpack_public_path__ + "static/media/claims-magic-moment.fb4b4f07c9ef66bfebbc6495956ab6e3.svg";
export { ForwardRef as ReactComponent };